export * from './config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-webstorage/dist/interfaces/index.js
// module id = 1053
// module chunks = 3